import { render, staticRenderFns } from "./PasswordCard.vue?vue&type=template&id=33e48338&scoped=true&"
import script from "./PasswordCard.vue?vue&type=script&lang=js&"
export * from "./PasswordCard.vue?vue&type=script&lang=js&"
import style0 from "./PasswordCard.vue?vue&type=style&index=0&id=33e48338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e48338",
  null
  
)

export default component.exports